import React from 'react'
import PropTypes from 'prop-types'
import * as Icon from 'react-feather'
import {defaultStyles} from '../../utils/Theme';
import { useHistory } from 'react-router-dom';

const AccessDenied = () => {
  const classes = defaultStyles();
  const history = useHistory();
  return (
    <div className="row u-mt-xlarge">
      <div className="col-md-6  u-pt-xlarge u-pb-xlarge offset-3 col-xl-6 u-mr-auto">
        <div className={`c-card`}>
          <span className="c-icon c-icon--large u-mb-small">
            <Icon.AlertTriangle className={classes.colorDanger} />
          </span>
          <h5 className={`u-mb-xsmall ${classes.colorDanger}`}>Access Denied</h5>
          <p className={`u-mb-medium  ${classes.colorDanger}`}>You do not have access to this page.</p>
          <button
            onClick={() => {
              history.goBack()
            }}
            className={`c-btn ${classes.buttonSecondary} u-text-center`}
          >
            Back
          </button>
        </div>
      </div>
    </div>
  )
}

export default AccessDenied;
